/* Product Tile Markup - You can play around with this to change the
information that appears on the Wishlisted Product tiles  */
var productCardMarkup = `<div class="swym-wishlist-grid class-items popup-cart-wrapper">
   {{#products}} 
   <a href="{{du}}"aria-label="{{dt}}" class="swym-wishlist-item swym-is-anchor cart--item">

     <div class="swym-wishlist-image-wrapper cart--item--image" style="padding: calc(var(--spacing--block) / 2)">
       <img alt="" class="swym-wishlist-image" src="{{iu}}">
     </div>
     <div style="display: flex; flex-direction: column; flex-grow: 1; align-items: flex-start;">
        <button class="swym-is-button cart--item--title ">
        <div class="swym-title swym-title-1" data-item="accent-text" style="font-size: var(--font--accent--size);">
            {{dt}}
        </div>
        </button>
	
        <div class="cart--item--variant-name swym-variant-title swym-text swym-title-2 swym-variant-title-spacer" data-item="accent-text" style="font-size: var(--font--accent--size); margin-left: 15px; margin-bottom: 4px;">
        {{variantinfo}}
        </div>
        <div class="cart--item--price swym-product-price swym-text swym-text-1">
        <div class="swym-product-final-price swym-value" data-item="nav-text" style="font-size: var(--font--paragraph--size);">
            {{cu}}{{pr}}
        </div>
        </div>
        <button id="swym-custom-add-toCartBtn" data-state-cart="{{#isInCart}} swym-added{{/isInCart}}" data-product-url="{{du}}" data-variant-id="{{epi}}" data-product-id="{{empi}}" data-item="nav-text" class="swym-add-to-cart-btn swym-button swym-button-1 swym-is-button swym-is-button">
        {{#isInCart}}Added to cart{{/isInCart}}{{^isInCart}}Add to cart{{/isInCart}}
        </button>
    </div>
   </a>
   {{/products}}
   <div class="cart--checkout-button" data-item="button" style="padding-top: var(--spacing--3);     border-top: 1px solid var(--bdr-color--general);">
          <a href="https://shopcasalina.com/pages/swym-wishlist"  style="width: 100%;text-align: center; text-decoration: none;">
		  View Wishlist
          </a>
        </div>
</div>`;

function getVariantInfo(variants) {
  try {
    let variantKeys = variants && variants != '[]' ? Object.keys(JSON.parse(variants)[0]) : [],
      variantinfo;
    if (variantKeys.length > 0) {
      variantinfo = variantKeys[0];
      if (variantinfo == 'Default Title') {
        variantinfo = '';
      }
    } else {
      variantinfo = '';
    }
    return variantinfo;
  } catch (err) {
    return variants;
  }
}

function onAddToCartClick(e) {
  e.preventDefault();
  var productId = e.currentTarget.getAttribute('data-product-id');
  var variantId = e.currentTarget.getAttribute('data-variant-id');
  var du = e.target.getAttribute('data-product-url');
  e.target.innerHTML = 'Adding..';
  window._swat.replayAddToCart(
    {
      empi: productId,
      du: du,
    },
    variantId,
    function (c) {
      e.target.innerHTML = 'Added to Cart';
      e.target.setAttribute('data-state-cart', 'swym-added');
      console.log('Successfully added product to cart.', c);
    },
    function (e) {
      console.log(e);
    }
  );
}

function onRemoveBtnClick(e) {
  e.preventDefault();
  var epi = +e.currentTarget.getAttribute('data-variant-id');
  var empi = +e.currentTarget.getAttribute('data-product-id');
  window._swat.fetch(function (products) {
    products.forEach(function (product) {
      if (epi && empi && product.epi == epi && product.empi == empi) {
        window._swat.removeFromWishList(product, function () {
          if (!window.SwymCallbacks) {
            window.SwymCallbacks = [];
          }
          window.SwymCallbacks.push(swymRenderWishlist);
        });
      }
    });
  });
}

function swymRenderWishlist(swat) {
  // Get wishlist items
  swat.fetch(function (products) {
    console.log(products);
    var wishlistContentsContainer = document.getElementById('wishlist-items-container');
    var formattedWishlistedProducts = products.map(function (p) {
      p = SwymUtils.formatProductPrice(p); // formats product price and adds currency to product Object
      p.isInCart = _swat.platform.isInDeviceCart(p.epi) || p.et == _swat.EventTypes.addToCart;
      p.variantinfo = p.vi ? getVariantInfo(p.vi) : '';
      return p;
    });
    var productCardsMarkup = SwymUtils.renderTemplateString(productCardMarkup, {
      products: formattedWishlistedProducts,
    });
    if (wishlistContentsContainer) {
      wishlistContentsContainer.innerHTML = productCardsMarkup;
      attachClickListeners();
    } else {
      console.log('Container not found, Wishlist Page element not found');
    }
  });
}

function attachClickListeners() {
  var addToCartButtons = document.querySelectorAll('#swym-custom-add-toCartBtn');
  var removeBtns = document.querySelectorAll('#swym-remove-productBtn');
  //   Add to cart Btns
  for (var i = 0; i < addToCartButtons.length; i++) {
    addToCartButtons[i].addEventListener('click', onAddToCartClick, false);
  }
  //   Remove Buttons
  for (var k = 0; k < removeBtns.length; k++) {
    removeBtns[k].addEventListener('click', onRemoveBtnClick, false);
  }
  console.log('Events attached!');
}

if (!window.SwymCallbacks) {
  window.SwymCallbacks = [];
}
window.SwymCallbacks.push(swymRenderWishlist); /* Init Here */
